import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { useIntl } from "react-intl";
import { Spin } from "antd";
import Empty from "../../../common/Empty";

const CanceledReservations = ({ data, setPage, isLoading, page }: any) => {
  const intl = useIntl();
  const cols = [
    intl.formatMessage({ id: "date" }),
    intl.formatMessage({ id: "cost" }),
    intl.formatMessage({ id: "status" }),
    intl.formatMessage({ id: "paymentStatus" }),
    intl.formatMessage({ id: "name" }),
  ];
  console.log(data);
  return isLoading ? (
    <Spin className="flex items-center justify-center" />
  ) : data?.data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={data?.data}
        page={page}
        total={data?.total}
        setPage={setPage}
      />
    </div>
  ) : (
    <Empty title="لا توجد حجوزات" subTitle="" />
  );
};

export default CanceledReservations;
